import { API } from 'aws-amplify';
import { toastr } from 'react-redux-toastr';

import {
	FETCH_SITES,
	FETCH_SITES_ERR,
	CREATE_SITE,
	CREATE_SITE_ERR,
	UPDATE_SITE,
	UPDATE_SITE_ERR,
	DELETE_SITE,
	DELETE_SITE_ERR,
	FETCH_SITE_TYPES,
	FETCH_SITE_TYPES_ERR,
	FETCH_COMMODITIES,
	FETCH_COMMODITIES_ERR,
	FETCH_SITE_INFO,
	FETCH_SITE_INFO_ERR,
	FETCH_SUBSITES,
	FETCH_SUBSITES_ERR,
	FETCH_SITE_CAPACITIES,
	FETCH_SITE_CAPACITIES_ERR,
	ADD_SITE_CAPACITIES,
	ADD_SITE_CAPACITIES_ERR,
	DELETE_SITE_CAPACITIES,
	DELETE_SITE_CAPACITIES_ERR
} from 'actions';
import config from 'config';
import { replacer } from 'utils';

export const fetchSubsiteInfo = (payload) => async (dispatch) => {
	const { id } = payload;

	const request = API.get(
		config.gainsApi.NAME,
		replacer(config.gainsApiEndpoints.fetchSubsiteInfo, {
			id
		}),
		{
			headers: {}
			//body: payload
		}
	);

	return request.then(
		(response) => {
			dispatch({
				type: FETCH_SUBSITES,
				payload: response
			});
			//dispatch(fetchSites());
		},
		(err) => {
			dispatch({
				type: FETCH_SUBSITES_ERR,
				payload: err
			});
		}
	);
};

export const fetchSites = () => async (dispatch) => {
	const request = API.get(
		config.gainsApi.NAME,
		config.gainsApiEndpoints.sites,
		{
			headers: {}
		}
	);

	return request.then(
		(response) =>
			dispatch({
				type: FETCH_SITES,
				payload: response
			}),
		(err) =>
			dispatch({
				type: FETCH_SITES_ERR,
				payload: err
			}),
			//toastr.error('Fetch sites', 'There was an error fetching sites')
	);
};

export const createSite = (payload) => async (dispatch) => {
	console.log('payload', payload);
	const request = API.post(
		config.gainsApi.NAME,
		config.gainsApiEndpoints.createSite,
		{
			headers: {},
			body: payload
		}
	);

	return request.then(
		(response) => {
			dispatch({
				type: CREATE_SITE,
				payload: response[0]
			});
			dispatch(fetchSites());
			toastr.success('Create Site', 'Site created successfully');
		},
		(err) => {
			dispatch({
				type: CREATE_SITE_ERR,
				payload: err
			});
			toastr.error('Create Site', 'There was an error creating the Site');
		}
	);
};

export const updateSiteAction = (payload) => async (dispatch) => {
	console.log("payload", payload)
	const { id, body } = payload;

	const request = API.put(
		config.gainsApi.NAME,
		replacer(config.gainsApiEndpoints.updateSite, {
			id
		}),
		{
			headers: {},
			body: body
		}
	);

	return request.then(
		(response) => {
			dispatch({
				type: UPDATE_SITE,
				payload: response[0]
			});
			dispatch(fetchSites());
			toastr.success('Update Site', 'Site updated successfully');
		},
		(err) => {
			dispatch({
				type: UPDATE_SITE_ERR,
				payload: err
			});
			toastr.error('Update Site', 'There was an error updating the Site');
		}
	);
};

export const deleteSite = (payload) => async (dispatch) => {
	const { id } = payload;

	const request = API.del(
		config.gainsApi.NAME,
		replacer(config.gainsApiEndpoints.deleteSite, {
			id
		}),
		{
			headers: {}
		}
	);

	return request.then(
		(response) => {
			dispatch({
				type: DELETE_SITE,
				payload: response[0]
			});
			dispatch(fetchSites());
			toastr.success('Delete Site', 'Site deleted successfully');
		},
		(err) => {
			dispatch({
				type: DELETE_SITE_ERR,
				payload: err
			});
			toastr.error('Delete Site', 'There was an error deleting the Site');
		}
	);
};

export const fetchSiteTypes = () => async (dispatch) => {
	const request = API.get(
		config.gainsApi.NAME,
		config.gainsApiEndpoints.siteTypes,
		{
			headers: {}
		}
	);

	return request.then(
		(response) =>
			dispatch({
				type: FETCH_SITE_TYPES,
				payload: response
			}),
		(err) =>
			dispatch({
				type: FETCH_SITE_TYPES_ERR,
				payload: err
			})
	);
};

export const fetchSiteCapacity = (payload) => async (dispatch) => {
	const { id } = payload;

	const request = API.get(
		config.gainsApi.NAME,
		replacer(config.gainsApiEndpoints.fetchSiteCapacities, {
			id
		}),
		{
			headers: {}
			//body: payload
		}
	);

	return request.then(
		(response) =>
			dispatch({
				type: FETCH_SITE_CAPACITIES,
				payload: response
			}),
		(err) =>
			dispatch({
				type: FETCH_SITE_CAPACITIES_ERR,
				payload: err
			})
	);
};

export const addSiteCapacity = (payload) => async (dispatch) => {
	const { id, body } = payload;

	const request = API.post(
		config.gainsApi.NAME,
		replacer(config.gainsApiEndpoints.addSiteCapacity, {
			id
		}),
		{
			headers: {},
			body: body
		}
	);

	console.log(payload);

	return request.then(
		(response) => {
			dispatch({
				type: ADD_SITE_CAPACITIES,
				payload: response
			});
			console.log('id', id);
			dispatch(fetchSiteCapacity({ id: id }));
			toastr.success(
				'Create Site Capacity',
				'Site capacity created successfully'
			);
		},
		(err) => {
			dispatch({
				type: ADD_SITE_CAPACITIES_ERR,
				payload: err
			});
			toastr.error(
				'Create Site Capacity',
				err?.response?.data?.message || 'There was an error creating the Site Capacity'
			);
		}
	);
};

export const updateSiteCapacity = ({ id, date, body }) => async (dispatch) => {
	try {
		await API.put(
			config.gainsApi.NAME,
			replacer(config.gainsApiEndpoints.updateSiteCapacity, { id }),
			{
				headers: {},
				queryStringParameters: { captured: date },
				body
			}
		);
		await dispatch(fetchSiteCapacity({ id }));
		toastr.success('Update Site Capacity', 'Site capacity updated successfully');
		return true;
	} catch (err) {
		toastr.error(
			'Update Site Capacity',
			err?.response?.data?.message || 'There was an error updating the Site Capacity'
		);
		return false;
	}
};

export const updateCaptureCapacities = ({ id }) => async () => {
	try {
		await API.post(
			config.qcApi.NAME,
			config.qcApiEndpoints.updateCaptureCapacities,
			{ headers: {}, body: { site_ids: [id] } }
		);
		toastr.success(
			'Update Processing and Index Tables',
			'Capture capacities in Processing and Index tables updated successfully'
		);
	} catch (err) {
		toastr.error(
			'Update Processing and Index Tables',
			err?.response?.data?.message ||
				'There was an error updating capture capacities in Processing and Index tables'
		);
	}
};

export const deleteSiteCapacity = (payload) => async (dispatch) => {
	const { id, date } = payload;

	const request = API.del(
		config.gainsApi.NAME,
		replacer(config.gainsApiEndpoints.deleteSiteCapacity, {
			id
		}),
		{
			headers: {},
			queryStringParameters: {
				captured: date
			}
		}
	);

	return request.then(
		(response) => {
			dispatch({
				type: DELETE_SITE_CAPACITIES,
				payload: response[0]
			});
			dispatch(fetchSiteCapacity({id: id}));
			toastr.success(
				'Delete site capacity',
				'Site capacity deleted successfully'
			);
		},
		(err) => {
			dispatch({
				type: DELETE_SITE_CAPACITIES_ERR,
				payload: err
			});
			toastr.error(
				'Delete site capacities error',
				err?.response?.data?.message || err?.message ||
					'There was an error deleting the site capacity'
			);
		}
	);
};

export const fetchSiteInfo = (payload) => async (dispatch) => {
	console.log(payload);
	const { id } = payload;

	const request = API.get(
		config.gainsApi.NAME,
		replacer(config.gainsApiEndpoints.siteInfo, {
			id
		}),
		{
			headers: {}
			//body: payload
		}
	);

	return request.then(
		(response) => {
			dispatch({
				type: FETCH_SITE_INFO,
				payload: response
			});
			//dispatch(fetchSites());
			return response;
		},
		(err) => {
			dispatch({
				type: FETCH_SITE_INFO_ERR,
				payload: err
			});
		}
	);
};

export const fetchCommodities = () => async (dispatch) => {
	const request = API.get(
		config.gainsApi.NAME,
		config.gainsApiEndpoints.commodities,
		{
			headers: {}
		}
	);

	return request.then(
		(response) =>
			dispatch({
				type: FETCH_COMMODITIES,
				payload: response
			}),
		(err) =>
			dispatch({
				type: FETCH_COMMODITIES_ERR,
				payload: err
			})
	);
};

export const downloadKml = async ({ id }) => {
	try {
		const url = await API.get(
			config.gainsApi.NAME,
			replacer(config.gainsApiEndpoints.kmlDownload, {
				id
			}),
			{
				headers: {},
				responseType: 'text'
			}
		);

		if (!url) {
			toastr.error('Missing url!');
			return;
		}
		// window.open(url, '_blank', 'download=test.kml');

		const a = document.createElement('a');
		//quotes removed since it doesn't work with npm package manager
		a.href = url.replace(/^"(.+(?="$))"$/, '$1');
		// a.setAttribute('download', `${id}.kml`);
		a.click();
		a.remove();
	} catch (err) {
		const innerMsg = err?.response?.data?.message;
		const message = `${err.message}. ${innerMsg ? innerMsg + '.' : ''}`;
		toastr.error(message);
	}
};
